import {Component, Input, OnInit} from '@angular/core';
import {ToastrService} from "ngx-toastr";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {Permission} from "../../Login/_guards/Permission";
import {ActivatedRoute, Router} from "@angular/router";
import {Blocco} from "../_Models/blocco";
import {ApiRestService} from "../api-rest.service";

@Component({
  selector: 'app-blocchi',
  templateUrl: './blocchi.component.html',
  styleUrls: ['./blocchi.component.scss']
})
export class BlocchiComponent implements OnInit {
  public items: Blocco[] = []
  @Input() HasAddButton: boolean = true;
  @Input() HasHeader: boolean = true;
  @Input() Editable: boolean = true;
  constructor(
    private toastService: ToastrService,
    public modalService: NgbModal,
    public permission: Permission,
    private router: Router,
    private route: ActivatedRoute,
    public apiRestService:ApiRestService
    ) { }

  ngOnInit(): void {
    this.refresh()
  }
  refresh(): void {
    this.apiRestService.BlocchiList({}).subscribe(data => this.items = data);
  }
  delete(blocco: Blocco){
    if(confirm("Sei sicuro di voler eliminare questo elemento dalla lista?"))
      this.apiRestService.BlocchiDelete(blocco).subscribe(()=> this.refresh() );
  }
  Open(blocco?: Blocco) {
    var urlToOpen: string = blocco&&!isNaN(blocco.id) ? `blocchi/blocchi/edit/${blocco.id.toString()}` : `blocchi/blocchi/edit`;
    this.router.navigate([this.route.snapshot.queryParams[urlToOpen] || urlToOpen,]);
  }
}
